import { RouteRecordRaw } from 'vue-router';
import { ssoRedirectCallbackGuard } from '~app/core/auth/guards';
import { FunctionalComponent } from 'vue';

export const ssoRedirectCallbackRoute: RouteRecordRaw = {
  path: '/auth/sso',
  name: 'sso',
  component: (): FunctionalComponent => void 0,
  beforeEnter: ssoRedirectCallbackGuard,
  meta: {
    public: true,
  },
};
